module.exports = __webpack_public_path__ + "img/jej4.264f64c9.png";